import { render, staticRenderFns } from "./CreateCampaignSourceReviewAddMoreGiftsModal.vue?vue&type=template&id=07c7698d&scoped=true"
import script from "./CreateCampaignSourceReviewAddMoreGiftsModal.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceReviewAddMoreGiftsModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceReviewAddMoreGiftsModal.vue?vue&type=style&index=0&id=07c7698d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7698d",
  null
  
)

export default component.exports